// components/features/shops/ShopRow.tsx
import { Shop } from "@cabukaka/types";
import TableRow from "../../ui/TableRow";
import { Store, MapPin, Phone, Star, Clock } from "lucide-react";

interface ShopRowProps {
  shop: Shop;
  onAction: (shop: Shop) => void;
  onSelect?: (shop: Shop, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

export default function ShopRow({ 
  shop, 
  onAction, 
  onSelect,
  isSelected = false,
  selectable = false
}: ShopRowProps) {
  return (
    <TableRow
      item={shop}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      {/* Colonne Boutique - toujours visible */}
      <td className="py-3 px-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center overflow-hidden flex-shrink-0">
            {shop.logo ? (
              <img src={shop.logo} alt={shop.name} className="w-full h-full object-cover" />
            ) : (
              <Store size={18} className="text-gray-400" />
            )}
          </div>
          <div>
            <span className="font-medium text-gray-800 block line-clamp-1">
              {shop.name}
            </span>
            <div className="flex items-center gap-2 mt-0.5">
              <div className={`text-xs px-1.5 py-0.5 rounded-full ${shop.open ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}`}>
                {shop.open ? 'Ouvert' : 'Fermé'}
              </div>
              {shop.badge && (
                <span className="text-xs text-orange-600">{shop.badge}</span>
              )}
            </div>
          </div>
        </div>
      </td>

      {/* Colonne Ville - cachée sur mobile */}
      <td className="hidden sm:table-cell py-3 px-4">
        <div className="flex items-center gap-2">
          <MapPin size={14} className="text-gray-400" />
          <span className="text-gray-600">{shop.location?.city || '-'}</span>
        </div>
      </td>

      {/* Colonne Téléphone - cachée sur mobile */}
      <td className="hidden sm:table-cell py-3 px-4">
        <div className="flex items-center gap-2">
          <Phone size={14} className="text-gray-400" />
          <span className="text-gray-600">{shop.phone || '-'}</span>
        </div>
      </td>

      {/* Colonne Note - cachée sur tablette */}
      <td className="hidden md:table-cell py-3 px-4">
        <div className="flex items-center gap-1">
          <Star size={14} className="fill-amber-400 text-amber-400" />
          <span className="text-gray-600">{shop.rating || 0}</span>
          <span className="text-gray-400 text-xs">({shop.reviews || 0})</span>
        </div>
      </td>

      {/* Colonne Délai - cachée sur tablette */}
      <td className="hidden lg:table-cell py-3 px-4">
        <div className="flex items-center gap-2">
          <Clock size={14} className="text-gray-400" />
          <span className="text-gray-600">{shop.deliveryTime || '-'}</span>
        </div>
      </td>
    </TableRow>
  );
}